
import React, { useState, useRef, useMemo, useEffect } from "react";
import JoditEditor from "jodit-react";
import { Container, Row, Col, Button, Tabs, Tab, Modal } from "react-bootstrap";
import ShowAlert from "../alert";
import { Field, FormikProvider, Form, useFormik } from "formik";
import SwaranandhraService from "../../Services/SwaranandhraService";
import Menubar from "../Menubar";
import MasterService from "../../Services/MasterService";
import * as DESUI from "react-bootstrap";
import Swal from "sweetalert2"; import { FaRegSave, FaDownload, FaEye, FaFileWord } from "react-icons/fa"; import { FaArrowRightLong } from "react-icons/fa6"; import { PieChart, Pie, Tooltip, Cell, LabelList } from 'recharts'; import { IoPrint } from "react-icons/io5"; import backgroundImage from '../../cover.jpg'; import { ImPrinter } from "react-icons/im"; import { store } from "../../App"; import { RiCloseCircleLine } from "react-icons/ri"; import ListGroup from "react-bootstrap/ListGroup"; import { AiOutlineSearch } from "react-icons/ai"; import { saveAs } from 'file-saver'; import image1 from "../../1.png"; import image2 from "../../2.png"; import image3 from "../../3.png"; import { Link } from "@mui/material";

import { MdOutlinePictureAsPdf } from "react-icons/md";
const BookGeneration = ({ placeholder = "" }) => {

  const contentRef = useRef();
const [key, setKey] = useState("coverpage"); const [isDisabled, setIsDisabled] = useState(false); const [distlist, setDistlist] = useState(); 
const [mandallist, setMandallist] = useState(); const [distEnb, setDistEnb] = useState(false); const [manEnb, setManEnb] = useState(false); 
const [addModal, setAddModal] = useState(false); const [addModal1, setAddModal1] = useState(false); 
const [addModal2, setAddModal2] = useState(false); const [addModal3, setAddModal3] = useState(false); const [addModal4, setAddModal4] = useState(false); 
const [addModal5, setAddModal5] = useState(false); const [generalinfo, setGeneralinfo] = useState(""); const [mandalprofile, setMandalprofile] = useState(""); 
const [economictext1, setEconomictext1] = useState(""); const [economictext2, setEconomictext2] = useState(""); const [primarytext, setPrimarytext] = useState(""); 
const [industrytext, setIndustrytext] = useState(""); const [servicetext, setServicetext] = useState(""); const [targettext, setTargettext] = useState(""); const [wayforward, setWayforward] = useState(""); 
const [indexPage, setIndexPage] = useState(""); const [data, setData] = useState([]); const [data2, setData2] = useState([]); const [data3, setData3] = useState([]); const [data4, setData4] = useState([]); const [data5, setData5] = useState([]); 
const [data51, setData51] = useState([]); const [data52, setData52] = useState([]); const [data53, setData53] = useState([]); const [data54, setData54] = useState([]); const [data1, setData1] = useState([]); const [enb, setEnb] = useState(false); 
const [subEnb, setSubEnb] = useState(false); const [subEnb1, setSubEnb1] = useState(false); const [indexdata, setIndexdata] = useState(); const [indexEnb, setIndexEnb] = useState(false); const [statusData, setStatusData] = useState([]);
const [searchTextStatus, setSearchTextStatus] = useState(""); const [enteredtabs, setEnteredtabs] = useState(""); const [bookfreez, setBookfreez] = useState("");

  let username = localStorage.getItem("username"); let roleid = localStorage.getItem("role"); let district = localStorage.getItem("districtid"); let mandal = localStorage.getItem("mandalid")

  const [base64Stringimg1, setBase64Stringimg1] = useState(""); const [base64Stringimg2, setBase64Stringimg2] = useState(""); const [base64Stringimg3, setBase64Stringimg3] = useState(""); const [mandalname, setMandalname] = useState(""); const [districtname, setDistrictname] = useState("");

  const formik = useFormik({
    initialValues: { userId: "", district_id: "", mandalmap: "", coverpic1: "", coverpic2: "", notefilemla: "", notfilecollecter: "", notefilemla1: "", pieImage: "", notecollectorPic1: "", bookfreez: [], Pagelist: [], },

  })


  React.useEffect(() => {
    if ((roleid === "2") || (roleid === "10")) {
      setDistEnb(true)
      setManEnb(false)
    }
    if (roleid === "3") {
      setDistEnb(true)
      setManEnb(true)
    }
    if (roleid === "5") {
      setDistEnb(false)
      setManEnb(false)
    }
    district !== "0"
  ? formik.setFieldValue("district_id", district)
  : formik.setFieldValue("district_id", "");

    let params = { "district_id": district }
    MasterService.getMandals(params).then((res) => {
      if (res.data) { let options = res.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); }); setMandallist(options); }
    });
    formik.setFieldValue("mandal_id", mandal !== "0" && mandal !== "00" ? mandal : "");

  }, [])



  const editorRefs = useRef({});


  const configEditor = useMemo(
    () => ({
      readonly: false,
      placeholder: placeholder,
      toolbar: true,
      buttons: [ 'bold', 'italic', 'underline', 'strikethrough', 'eraser', '|', 'paragraph', 'brush', 'fontsize', 'table', 'image', 'align', 'print', 'undo', 'redo', 'cut', 'copy', 'paste', 'superscript', 'subscript', 'math', ],
      uploader: { insertImageAsBase64URI: true, },
      cleanHTML: false,
      removeButtons: [ 'source', 'video', 'file', 'link', 'copyformat', 'selectall', 'preview', 'symbol', 'fullsize', 'outdent', 'indent', 'speechRecognition' ],
      events: {
        beforePaste: (event) => { const clipboardData = event.clipboardData || window.clipboardData; let pastedData = clipboardData.getData('Text'); pastedData = pastedData.replace(/([a-z])([A-Z])/g, '$1 $2'); event.preventDefault(); editorRefs.current["mandaldetails"].editor.selection.insertHTML(pastedData); },
      },
    }),
    [placeholder]
  );
  useEffect(() => {
    MasterService.getDistricts().then((response) => {
      if (response.data) { let options = response.data.map((item, i) => { return ( <option key={item.id} value={item.id}> {item.value} </option> ); }); setDistlist(options); }
    });

    if (roleid === "3") {
      let params = { "userId": username, "distId": district, "mandalId": mandal }
      SwaranandhraService.getGvaTablesdata(params).then((res) => {
        if (res.data.SCODE === "01") { setData(res.data.GVA_Table1); setData1(res.data.GVA_Table2); setData2(res.data.GVA_Table3); setData3(res.data.GVA_Table4); setData4(res.data.GVA_Table5); }
      });

      SwaranandhraService.getTargetstablesdata(params).then((res) => { if (res.data.SCODE === "01") { setData5(res.data.TARGETS_Table1); setData51(res.data.TARGETS_Table2); setData52(res.data.TARGETS_Table3); setData53(res.data.TARGETS_Table4); setData54(res.data.TARGETS_Table5); } });
    }


    if (roleid === "2" || roleid === "10") {
      let params = { "userId": username, "distId": district, "status": "bookStatus" }
      SwaranandhraService.getStatusOfMandalVisionBook(params).then((res) => {
        if (res.data.SCODE === "01") { setStatusData(res.data.SDESC); res.data.SDESC.forEach((item, index) => { formik.setFieldValue(`bookfreez[${index}]`, item.book_freez || ""); }); }
      });
    }
  }, []);


  const pieChartData = data1?.slice(0, -1).map((item) => ({
    name: item.bs_name,
    value: item.contribution,
    gmdp: item.gmdp,
    color:item.bs_name === 'Agriculture & Allied' ? '#4CAF50' : item.bs_name === 'Industry' ? '#FF9800': item.bs_name === 'Services' ? '#2196F3' : '#FFC107',
  }));


  const SUPPORTED_FORMATS = ['image/jpeg', 'image/png']; const MAX_FILE_SIZE = 500 * 1024; const [fileErrors, setFileErrors] = useState({});

  const handleFileUpload = (event) => {
    const { name, files } = event.target;

    setFileErrors((prevErrors) => ({ ...prevErrors, [name]: '', }));
    formik.setFieldValue(name, '');

    if (files && files.length > 0) {
      const file = files[0];

      if (!SUPPORTED_FORMATS.includes(file.type)) {
        setFileErrors((prevErrors) => ({
          ...prevErrors,
          [name]: 'Unsupported file format. Please upload JPEG or PNG.',
        }));
        return; 
      }

      if (file.size > MAX_FILE_SIZE) {
        setFileErrors((prevErrors) => ({ ...prevErrors, [name]: 'Image size must be below 500KB', }));
        return; 
      }

      const reader = new FileReader();

      reader.onloadend = () => {
        const img = new Image();
        img.src = reader.result;

        img.onload = () => { formik.setFieldValue(name, reader.result); };
        img.onerror = () => {
          setFileErrors((prevErrors) => ({ ...prevErrors, [name]: 'Invalid image file', }));
        };
      };

      reader.readAsDataURL(file);
    }
  };


  useEffect(() => { fetchImageAsBase64(image1, setBase64Stringimg1); fetchImageAsBase64(image2, setBase64Stringimg2); fetchImageAsBase64(image3, setBase64Stringimg3); }, []);

  const fetchImageAsBase64 = (image, setBase64String) => {
    fetch(image).then(response => response.blob()).then(blob => { const reader = new FileReader(); reader.onloadend = () => { setBase64String(reader.result); }; reader.readAsDataURL(blob); }).catch(error => { console.error("Error converting image to base64:", error); });
  };

  
  useEffect(() => {
    if (roleid === "3") {
      const fetchData = () => {
        let params = { "userId": username, "distId": district, "mandalId": mandal };
        store.dispatch({ type: "SHOW_SPINNER" });
        SwaranandhraService.getViewMandalVisionBook(params).then((res) => {
            if (res?.data?.SCODE === "01") {
              const general_information = res.data.SDESC.general_information; const mandal_profile = res.data.SDESC.mandal_profile; const economic_perspective_textbox_1 = res.data.SDESC.economic_perspective_textbox_1; const economic_perspective_textbox_2 = res.data.SDESC.economic_perspective_textbox_2; const primary_sector_textbox = res.data.SDESC.primary_sector_textbox; const industry_sector_textbox = res.data.SDESC.industry_sector_textbox; const service_sector_textbox = res.data.SDESC.service_sector_textbox; const targets_text = res.data.SDESC.targets_text; const way_forward = res.data.SDESC.way_forward; const cover_pic_1 = res.data.SDESC.cover_pic_1; const cover_pic_2 = res.data.SDESC.cover_pic_2; const mla_pic = res.data.SDESC.mla_pic; const collector_pic = res.data.SDESC.collector_pic; const collector_pic_1 = res.data.SDESC.collector_pic_1; const mla_pic1 = res.data.SDESC.mla_pic_1; const mandal_map = res.data.SDESC.mandal_map; const index_page = res.data.SDESC.index_page;
              setIndexdata(index_page); setIndexPage(index_page); setGeneralinfo(general_information); setMandalprofile(mandal_profile); setEconomictext1(economic_perspective_textbox_1); setEconomictext2(economic_perspective_textbox_2); setPrimarytext(primary_sector_textbox); setIndustrytext(industry_sector_textbox); setServicetext(service_sector_textbox); setTargettext(targets_text); setWayforward(way_forward);
              formik.setFieldValue("coverpic1", cover_pic_1 || ""); formik.setFieldValue("coverpic2", cover_pic_2 || ""); formik.setFieldValue("notefilemla", mla_pic || ""); formik.setFieldValue("mandalmap", mandal_map || ""); formik.setFieldValue("notefilemla1", mla_pic1 || ""); formik.setFieldValue("notfilecollecter", collector_pic || ""); formik.setFieldValue("notecollectorPic1", collector_pic_1 || "");
              setEnb(true); setSubEnb(false); setSubEnb1(false); setIndexEnb(false); setEnteredtabs(res.data.EnteredTabsCount); setMandalname(res.data.mandal_name); setDistrictname(res.data.district_name); setBookfreez(res.data.SDESC.book_freez);
            } else if (res?.data?.SCODE === "02") {
              ShowAlert(res.data.SDESC, "warning")
            }
          }).catch((error) => { console.error('Error fetching data:', error); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
      };
      fetchData();
    }
  }, []);

  const fetchData1 = () => {
    let params = { "userId": username, "distId": district, "mandalId": mandal };

    SwaranandhraService.getViewMandalVisionBook(params).then((res) => {
        if (res?.data?.SCODE === "01") {
          const general_information = res.data.SDESC.general_information; const mandal_profile = res.data.SDESC.mandal_profile; const economic_perspective_textbox_1 = res.data.SDESC.economic_perspective_textbox_1; const economic_perspective_textbox_2 = res.data.SDESC.economic_perspective_textbox_2; const primary_sector_textbox = res.data.SDESC.primary_sector_textbox; const industry_sector_textbox = res.data.SDESC.industry_sector_textbox; const service_sector_textbox = res.data.SDESC.service_sector_textbox; const targets_text = res.data.SDESC.targets_text; const way_forward = res.data.SDESC.way_forward; const cover_pic_1 = res.data.SDESC.cover_pic_1; const cover_pic_2 = res.data.SDESC.cover_pic_2; const mla_pic = res.data.SDESC.mla_pic; const collector_pic = res.data.SDESC.collector_pic; const mla_pic1 = res.data.SDESC.mla_pic_1; const collector_pic_1 = res.data.SDESC.collector_pic_1; const mandal_map = res.data.SDESC.mandal_map;
          setIndexdata(res.data.SDESC.index_page); setGeneralinfo(general_information); setMandalprofile(mandal_profile); setEconomictext1(economic_perspective_textbox_1); setEconomictext2(economic_perspective_textbox_2); setPrimarytext(primary_sector_textbox); setIndustrytext(industry_sector_textbox); setServicetext(service_sector_textbox); setTargettext(targets_text); setWayforward(way_forward);
          formik.setFieldValue("coverpic1", cover_pic_1 || ""); formik.setFieldValue("coverpic2", cover_pic_2 || ""); formik.setFieldValue("mandalmap", mandal_map || ""); formik.setFieldValue("notefilemla", mla_pic || ""); formik.setFieldValue("notefilemla1", mla_pic1 || ""); formik.setFieldValue("notfilecollecter", collector_pic || ""); formik.setFieldValue("notecollectorPic1", collector_pic_1 || "");
          setEnteredtabs(res.data.EnteredTabsCount); setMandalname(res.data.mandal_name); setDistrictname(res.data.district_name); setBookfreez(res.data.SDESC.book_freez);
        } else {
          ShowAlert("error occured", "error")
        }
      }).catch((error) => { console.error('Error fetching data:', error); });
  };

const handleClose = () => { setAddModal(false); }; const handleClose2 = () => { setAddModal2(false); }; const handleClose3 = () => { setAddModal3(false); }; const handleClose4 = () => { setAddModal4(false); }; const handleClose5 = () => { setAddModal5(false); };

  const handleSubmit = (tabKey, tab) => {
    const htmlContent = editorRefs.current[tabKey]?.value.trim();
    if (htmlContent === `<p><br></p>` || htmlContent === '') { Swal.fire({ icon: "warning", title: "Empty Content", text: "Please enter some content before posting.", }); return; }

    if (tab === 1) {
      let params = { tab, userId: username, distId: district, mandalId: mandal, coverPic1: formik.values.coverpic1, coverPic2: formik.values.coverpic2, mlaPic: formik.values.notefilemla, mlaPic1: formik.values.notefilemla1, collectorPic: formik.values.notfilecollecter, indexPage: indexdata, collectorPic1: formik.values.notecollectorPic1, };
if (!params.coverPic1) { ShowAlert("Upload Cover Pic1", "warning"); return; } else if (!params.coverPic2) { ShowAlert("Upload Cover Pic2", "warning"); return; } else if (!params.collectorPic) { ShowAlert("Upload Collector Message", "warning"); return; }

      store.dispatch({ type: "SHOW_SPINNER" });
      SwaranandhraService.getMandalVisionBook(params).then((res) => {
        if (res.data.SCODE === "01") { ShowAlert(res.data.SDESC, "success"); fetchData1(); } else { ShowAlert(res.data.SDESC, "error"); }
      }).catch((error) => { console.error("Error submitting data:", error); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    }

  };



  const handleSubmit1 = (tabKey, tab) => {
    const htmlContent = editorRefs.current[tabKey]?.value.trim();
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlContent;
    if (htmlContent === `<p><br></p>` || htmlContent === '') {
      Swal.fire({ icon: "warning", title: "Empty Content", text: "Please enter some content before posting.", });
      return;
    }
    if (tab === 2) {
      let params = { "tab": tab, "userId": username, "distId": district, "mandalId": mandal, "generalInformation": htmlContent, }
      store.dispatch({ type: "SHOW_SPINNER" });
      SwaranandhraService.getMandalVisionBook(params).then((resp) => {
        if (resp.data.SCODE === "01") { ShowAlert(resp.data.SDESC, "success"); fetchData1(); } else { ShowAlert(resp.data.SDESC, "error"); }
      }).catch((error) => { console.error("Error submitting data:", error); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    }};


  const handleSubmit2 = (tabKey, tab) => {
    const htmlContent = editorRefs.current[tabKey]?.value.trim();
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlContent;

    if (htmlContent === `<p><br></p>` || htmlContent === '') { Swal.fire({ icon: "warning", title: "Empty Content", text: "Please enter some content before posting.", }); return; }

    if (tab === 3) {
      let params = { tab: tab, userId: username, distId: district, mandalId: mandal, mandalMap: formik.values.mandalmap, mandalProfile: htmlContent };
      if (!params.mandalMap) { ShowAlert("Please Upload Mandal Map", "", "warning"); return; }
      store.dispatch({ type: "SHOW_SPINNER" });
      SwaranandhraService.getMandalVisionBook(params).then((res) => {
          if (res.data.SCODE === "01") {
            ShowAlert(res.data.SDESC, "success"); fetchData1();
          } else {
            ShowAlert(res.data.SDESC, "error");
          }
        }).catch((error) => { console.error("Error submitting data:", error); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
}};



  const handleSubmit3 = (tabKey, tab) => {
    const htmlContent1 = editorRefs.current["economic"]?.value.trim();
    if (!htmlContent1 || htmlContent1 === `<p><br></p>`) { Swal.fire({ icon: "warning", title: "Empty Content", text: "Please enter some content for economic before posting.", }); return; }
    const tableElement1 = document.getElementById("my-table"); const tableHTML1 = tableElement1 ? tableElement1.outerHTML : ""; const combined1 = `${tableHTML1}<br>${htmlContent1}`;
    const htmlContent2 = editorRefs.current["economic1"]?.value.trim();
    if (!htmlContent2 || htmlContent2 === `<p><br></p>`) { Swal.fire({ icon: "warning", title: "Empty Content", text: "Please enter some content for economic1 before posting.", }); return; }
    const tableElement2 = document.getElementById("my-table1");
    const tableHTML2 = tableElement2 ? tableElement2.outerHTML : "";
    const combined2 = `${tableHTML2}<br>${htmlContent2}`;
    const htmlContent3 = editorRefs.current["economic2"]?.value.trim();
    if (!htmlContent3 || htmlContent3 === `<p><br></p>`) { Swal.fire({ icon: "warning", title: "Empty Content", text: "Please enter some content for economic2 before posting.", }); return; }
    const tableElement3 = document.getElementById("my-table2");
    const tableHTML3 = tableElement3 ? tableElement3.outerHTML : "";

    const combined3 = `<h3>Sectoral Breakup of Mandal GVA:</h3> <h4>1. Primary Sector (Agriculture & Allied) : </h4> ${tableHTML3}<br>${htmlContent3}`;

    const htmlContent4 = editorRefs.current["economic3"]?.value.trim();
    if (!htmlContent4 || htmlContent4 === `<p><br></p>`) { Swal.fire({ icon: "warning", title: "Empty Content", text: "Please enter some content for economic3 before posting.", }); return; }
    const tableElement4 = document.getElementById("my-table3");
    const tableHTML4 = tableElement4 ? tableElement4.outerHTML : "";
    const combined4 = `<h4>2. Secondary Sector (Industries): </h4> ${tableHTML4}<br>${htmlContent4}`;

    const htmlContent5 = editorRefs.current["economic4"]?.value.trim();
    if (!htmlContent5 || htmlContent5 === `<p><br></p>`) { Swal.fire({ icon: "warning", title: "Empty Content", text: "Please enter some content for economic4 before posting.", }); return; }
    const tableElement5 = document.getElementById("my-table4"); const tableHTML5 = tableElement5 ? tableElement5.outerHTML : ""; const combined5 = `<h4>3. Tertiary Sector (Services): </h4> ${tableHTML5}<br>${htmlContent5}`;

    if (tab === 4) {
      let params = { "tab": tab, "userId": username, "distId": district, "mandalId": mandal, "economicPerspectiveTextbox1": htmlContent1, "economicPerspectiveTextbox2": htmlContent2, "primarySectorTextbox": htmlContent3, "industrySectorTextbox": htmlContent4, "serviceSectorTextbox": htmlContent5, "economicPerspectiveDiv1": combined1, "economic_perspectiveDiv2": combined2, "primarySectorDiv": combined3, "industrySectorDiv": combined4, "serviceSectorDiv": combined5, }
      store.dispatch({ type: "SHOW_SPINNER" });
      SwaranandhraService.getMandalVisionBook(params).then((res) => {
        if (res.data.SCODE === "01") { ShowAlert(res.data.SDESC, "success"); fetchData1(); } else { ShowAlert(res.data.SDESC, "error"); }
      }).catch((error) => { console.error("Error submitting data:", error); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    }

  };

  const Preview = () => {
    let payload = { "tab": 4, "distId": district, "mandalId": mandal }
    store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.Pdfpreview(payload).then((responsee) => {
        if (responsee.data) { const url = window.URL.createObjectURL( new Blob([responsee.data], { type: "application/pdf" }) ); window.open( url, "Popup", "toolbar=no,scrollbars=yes,resizable=yes,width=600,height=600" ); }
      }).catch((error) => { console.error("Error:", error); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  }

  const Preview1 = () => {
    let params = { "tab": 5, "distId": district, "mandalId": mandal }
    store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.Pdfpreview(params).then((res) => {
        if (res.data) { const url = window.URL.createObjectURL( new Blob([res.data], { type: "application/pdf" }) ); window.open( url, "Popup", "toolbar=no,scrollbars=yes,resizable=yes,width=600,height=600" ); }
      }).catch((error) => { console.error("Error:", error); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };

  const Preview2 = () => {
    let params2 = { "tab": 1, "distId": district, "mandalId": mandal }
    store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.Pdfpreview(params2).then((res2) => {
        if (res2.data) { const url = window.URL.createObjectURL( new Blob([res2.data], { type: "application/pdf" }) ); window.open( url, "Popup", "toolbar=no,scrollbars=yes,resizable=yes,width=600,height=600" ); }
      }).catch((error) => { console.error("Error:", error); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  }


  const Preview3 = () => {
    let params3 = { "tab": 2, "distId": district, "mandalId": mandal }
    store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.Pdfpreview(params3).then((res3) => {
        if (res3.data) { const url = window.URL.createObjectURL( new Blob([res3.data], { type: "application/pdf" }) ); window.open( url, "Popup", "toolbar=no,scrollbars=yes,resizable=yes,width=600,height=600" ); }
      }).catch((error) => { console.error("Error:", error); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };

  const Preview4 = () => {
    let params4= { "tab": 3, "distId": district, "mandalId": mandal }
    store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.Pdfpreview(params4).then((res4) => {
        if (res4.data) { const url = window.URL.createObjectURL( new Blob([res4.data], { type: "application/pdf" }) ); window.open( url, "Popup", "toolbar=no,scrollbars=yes,resizable=yes,width=600,height=600" ); }
      }).catch((error) => { console.error("Error:", error); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };


  const Preview5 = () => {
    let params5 = { "tab": 6, "distId": district, "mandalId": mandal }
    store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.Pdfpreview(params5).then((res5) => {
        if (res5.data) { const url = window.URL.createObjectURL( new Blob([res5.data], { type: "application/pdf" }) ); window.open( url, "Popup", "toolbar=no,scrollbars=yes,resizable=yes,width=600,height=600" ); }
      }).catch((error) => { console.error("Error:", error); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };



  const handleSubmit4 = (tabKey, tab) => {
    const htmlContent = editorRefs.current[tabKey]?.value.trim();
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlContent;
    if (htmlContent === `<p><br></p>` || htmlContent === '') { Swal.fire({ icon: "warning", title: "Empty Content", text: "Please enter some content before posting.", }); return; }
    const tableElement = document.getElementById("my-table5"); const tableHTML = tableElement ? tableElement.outerHTML : ""; const tableElement1 = document.getElementById("my-table51"); const tableHTML1 = tableElement1 ? tableElement1.outerHTML : ""; const tableElement2 = document.getElementById("my-table52"); const tableHTML2 = tableElement2 ? tableElement2.outerHTML : ""; const tableElement3 = document.getElementById("my-table53"); const tableHTML3 = tableElement3 ? tableElement3.outerHTML : ""; const tableElement4 = document.getElementById("my-table54"); const tableHTML4 = tableElement4 ? tableElement4.outerHTML : "";
const combined = ` <div class='sa-title'> <p>The Mandal Action Plan primarily targets the development of the Primary sector, which includes:<br/> Agriculture, Horticulture, Livestock, Fisheries, and Forestry</p> ${data5.length > 0 ? ` <h4>Agriculture Sector</h4> ${tableHTML} ` : ''} ${data51.length > 0 ? ` <h4>Horticulture Sector</h4> ${tableHTML1} ` : ''} ${data52.length > 0 ? ` <h4>Livestock Sector</h4> ${tableHTML2} ` : ''} ${data53.length > 0 ? ` <h4>Fisheries Sector</h4> ${tableHTML3} ` : ''} ${data54.length > 0 ? ` <h4>Forestry Sector</h4> ${tableHTML4}<br> ` : ''} ${htmlContent} </div> `;

    if (tab === 5) {
      let params5 = { "tab": tab, "userId": username, "distId": district, "mandalId": mandal, "targetsText": htmlContent, "targetsDiv": combined }
      store.dispatch({ type: "SHOW_SPINNER" });
      SwaranandhraService.getMandalVisionBook(params5).then((res5) => {
        if (res5.data.SCODE === "01") { ShowAlert(res5.data.SDESC, "success"); fetchData1(); } else { ShowAlert(res5.data.SDESC, "error"); }
      }).catch((error) => { console.error("Error submitting data:", error); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    }};


  const handleSubmit5 = (tabKey, tab) => {
    const htmlContent = editorRefs.current[tabKey]?.value.trim();
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlContent;
    if (htmlContent === `<p><br></p>` || htmlContent === '') { Swal.fire({ icon: "warning", title: "Empty Content", text: "Please enter some content before posting.", }); return; }
    if (tab === 6) {
      let params6 = { "tab": tab, "userId": username, "distId": district, "mandalId": mandal, "wayForward": htmlContent }
      store.dispatch({ type: "SHOW_SPINNER" });
      SwaranandhraService.getMandalVisionBook(params6).then((res6) => {
        if (res6.data.SCODE === "01") { ShowAlert(res6.data.SDESC, "success"); fetchData1(); } else { ShowAlert(res6.data.SDESC, "error"); }
      }).catch((error) => { console.error("Error submitting data:", error); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    }};


  const handleSubmit6 = () => {
    let params = { distId: district, mandalId: mandal, };
    store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.getgeneratepdf(params).then((res) => {
        if (res.data) { const url = window.URL.createObjectURL( new Blob([res.data], { type: "application/pdf" }) ); window.open( url, "Popup", "toolbar=no,scrollbars=yes,resizable=yes,width=600,height=600" ); }
      }).catch((error) => { console.error("Error:", error); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };
 

  const exportToWord = () => {
    return new Promise((resolve, reject) => {
      const pieChartElement = document.getElementById('my-table1pie');
    const coverPicElement = document.getElementById('coverpicid'); // Cov
      if (pieChartElement && coverPicElement) {
        const svgElement = pieChartElement.querySelector('svg'); const serializer = new XMLSerializer(); const svgString = serializer.serializeToString(svgElement);
        const img = new Image(); const img1 = new Image(); const img2 = new Image(); const img3 = new Image(); const coverPic1 = new Image(); const coverPic2 = new Image();
        const img1Base64 = base64Stringimg1; const img2Base64 = base64Stringimg2; const img3Base64 = base64Stringimg3; const coverPic1Base64 = formik.values.coverpic1 || ''; const coverPic2Base64 = formik.values.coverpic2 || '';
        const svgBase64 = `data:image/svg+xml;base64,${btoa(svgString)}`;
        img.onload = function () {
          const canvas = document.createElement('canvas'); const ctx = canvas.getContext('2d'); const pieChartWidth = 500; const labelsWidth = 200; const canvasWidth = pieChartWidth + labelsWidth; const canvasHeight = 350; canvas.width = canvasWidth; canvas.height = canvasHeight; ctx.drawImage(img, 0, 0, pieChartWidth, canvasHeight); const labelXPosition = pieChartWidth + 20; const labelYStart = 20; const labelHeight = 30;
          
              pieChartData.forEach((entry, index) => { const labelYPosition = labelYStart + index * labelHeight; ctx.fillStyle = entry.color; ctx.fillRect(labelXPosition, labelYPosition, 20, 20); ctx.fillStyle = 'black'; ctx.font = '16px Arial'; ctx.fillText(entry.name, labelXPosition + 30, labelYPosition + 15); });
 const base64Image = canvas.toDataURL('image/png'); canvas.width = 620; canvas.height = 900;
          img1.onload = function () {
            ctx.drawImage(img1, 0, 0, 620, 200); 
  
            img2.onload = function () { ctx.drawImage(img2, 0, 210, 620, 200); ctx.fillStyle = 'orange'; ctx.font = 'bold 20px Arial'; const mandalText = `Mandal:`; const districtText = `District:`; const mandalLabelWidth = ctx.measureText(mandalText).width; const mandalNameWidth = ctx.measureText(mandalname).width; const districtLabelWidth = ctx.measureText(districtText).width; const districtNameWidth = ctx.measureText(districtname).width;
              const maxLabelWidth = Math.max(mandalLabelWidth, districtLabelWidth);
              const startX = (canvasWidth - (maxLabelWidth + Math.max(mandalNameWidth, districtNameWidth) + 20)) / 2; 
  
              ctx.fillText(mandalText, startX, 310); 
              ctx.fillStyle = 'black'; 
              ctx.fillText(mandalname, startX + mandalLabelWidth + 20, 310); 
  
              ctx.fillStyle = 'blue'; 
              ctx.fillText(districtText, startX, 360); 
              ctx.fillStyle = 'black'; 
              ctx.fillText(districtname, startX + districtLabelWidth + 20, 360); 
  
              coverPic1.onload = function () { ctx.drawImage(coverPic1, 0, 410, 310, 200); coverPic2.onload = function () { ctx.drawImage(coverPic2, 310, 410, 310, 200); img3.onload = function () { ctx.drawImage(img3, 0, 610, 620, 180); const Coverbase64Image = canvas.toDataURL('image/png');
  
           

                const htmlContentind = editorRefs.current["indexPage"].getEditorValue();
                let htmlContentgen = editorRefs.current["generalinfo"].getEditorValue();
                if (htmlContentgen) {
                  const tempElement = document.createElement("div");
                  tempElement.innerHTML = htmlContentgen;
                  const tables = tempElement.querySelectorAll("table");
                  tables.forEach((table) => { table.style.width = "100%"; table.style.borderCollapse = "collapse"; const cells = table.querySelectorAll("td, th"); cells.forEach((cell) => { cell.style.padding = "1px"; cell.style.fontSize = "10px"; }); });
                  htmlContentgen = tempElement.innerHTML;
                }
                let htmlContentmandprof = editorRefs.current["mandaldetails"].getEditorValue();
                if (htmlContentmandprof) {
                  const tempElement = document.createElement("div");
                  tempElement.innerHTML = htmlContentmandprof;
                  const tables = tempElement.querySelectorAll("table");
                  tables.forEach((table) => { table.style.width = "100%"; table.style.borderCollapse = "collapse"; const cells = table.querySelectorAll("td, th"); cells.forEach((cell) => { cell.style.padding = "1px"; cell.style.fontSize = "10px"; }); });
                  htmlContentmandprof = tempElement.innerHTML;
                }
             
             
                let htmlContentwayfor = editorRefs.current["wayforward"].getEditorValue();
                if (htmlContentwayfor) {
                  const tempElement = document.createElement("div");
                  tempElement.innerHTML = htmlContentwayfor;
                  const tables = tempElement.querySelectorAll("table");
                  tables.forEach((table) => { table.style.width = "100%"; table.style.borderCollapse = "collapse"; const cells = table.querySelectorAll("td, th"); cells.forEach((cell) => { cell.style.padding = "1px"; cell.style.fontSize = "10px"; }); });
                  htmlContentwayfor = tempElement.innerHTML;
                }
             
                const htmlContent1 = editorRefs.current["economic"]?.value.trim(); const tableElement1 = document.getElementById("my-table"); const tableHTML1 = tableElement1 ? tableElement1.outerHTML : ""; const htmlContent2 = editorRefs.current["economic1"]?.value.trim(); const tableElement2 = document.getElementById("my-table1"); const tableHTML2 = tableElement2 ? tableElement2.outerHTML : "";const htmlContent3 = editorRefs.current["economic2"]?.value.trim(); const tableElement3 = document.getElementById("my-table2"); const tableHTML3 = tableElement3 ? tableElement3.outerHTML : ""; const htmlContent4 = editorRefs.current["economic3"]?.value.trim(); const tableElement4 = document.getElementById("my-table3"); const tableHTML4 = tableElement4 ? tableElement4.outerHTML : ""; const htmlContent5 = editorRefs.current["economic4"]?.value.trim(); const tableElement5 = document.getElementById("my-table4"); const tableHTML5 = tableElement5 ? tableElement5.outerHTML : "";
               
             
                let combinedHTMLmanddev = "";
                let htmlContentmandaldev = editorRefs.current["mandaldevelopment"]?.value.trim();
                if (htmlContentmandaldev) {
                  const tempElement = document.createElement("div");
                  tempElement.innerHTML = htmlContentmandaldev;
                  const tables = tempElement.querySelectorAll("table");
                  tables.forEach((table) => { table.style.width = "100%"; table.style.borderCollapse = "collapse"; const cells = table.querySelectorAll("td, th"); cells.forEach((cell) => { cell.style.padding = "1px"; cell.style.fontSize = "10px"; }); });
             
                  htmlContentmandaldev = tempElement.innerHTML;
                }
             
                const tableElementTar1 = document.getElementById("my-table5"); const tableHTMLtar1 = tableElementTar1 ? tableElementTar1.outerHTML : ""; const tableElementTar2 = document.getElementById("my-table51"); const tableHTMLtar2 = tableElementTar2 ? tableElementTar2.outerHTML : ""; const tableElementTar3 = document.getElementById("my-table52"); const tableHTMLtar3 = tableElementTar3 ? tableElementTar3.outerHTML : ""; const tableElementTar4 = document.getElementById("my-table53"); const tableHTMLtar4 = tableElementTar4 ? tableElementTar4.outerHTML : ""; const tableElementTar5 = document.getElementById("my-table54"); const tableHTMLtar5 = tableElementTar5 ? tableElementTar5.outerHTML : "";
             
                combinedHTMLmanddev += ` ${data5.length > 0 ? `<h5>Agriculture Sector</h5> ${tableHTMLtar1}` : ""} ${data51.length > 0 ? `<h5>Horticulture Sector</h5> ${tableHTMLtar2}` : ""} ${data52.length > 0 ? `<h5>Livestock Sector</h5> ${tableHTMLtar3}` : ""} ${data53.length > 0 ? `<h5>Fisheries Sector</h5> ${tableHTMLtar4}` : ""} ${data54.length > 0 ? `<h5>Forestry Sector</h5> ${tableHTMLtar5}` : ""} ${htmlContentmandaldev ? `${htmlContentmandaldev}` : ""}
            `;
            
 const notefileMLABase64 = formik.values.notefilemla || ""; const notefileMLA1Base64 = formik.values.notefilemla1 || ""; const notfileCollectorBase64 = formik.values.notfilecollecter || ""; const notfileCollector1Base64 = formik.values.notecollectorPic1 || ""; const mandalmapBase64 = formik.values.mandalmap || "";
             
 
                const docContent = `
                <html xmlns:w="urn:schemas-microsoft-com:office:word">
                <head>
                  <meta charset="utf-8">
                  <style>
                    body {
                      font-family: "Times New Roman", 'Poppins', sans-serif;
                      width: 100%;
                    }
                    
                 
                    table {
                      border-collapse: collapse;
                      width: 90%; 
                    }
                    th, td {
                      border: 1px solid black;
                      padding: 1px;
                      font-size: 11px;
                    }
                    .center {
                      text-align: center;
                      font-weight: bold;
                    }
                    .left {
                      text-align: left;
                    }
                    p {
                      font-size: 12px;
                    }
                    @page { size: A4; margin: 40px 25px; }
                    div.page-break {
                    page-break-after: always;
                    page-break-before: always;
                    break-after: always;
                  }
                  </style>
                </head>
                <body>
                <div>
                <img src="${Coverbase64Image}" alt="Background Image" style="width: 620px; object-fit: cover;" width="620" />
            
                       <div class="page-break">
                        ${notefileMLABase64 ? `
                          <span style="font-size:20px;">Honourable Minister Message</span>
                          <img src="${notefileMLABase64}" style="object-fit: cover;"  width="660" height="800"/>
                        ` : ''}
                  </div>
                 
                 
                 
                  <div class="page-break">
                     ${notefileMLA1Base64 ? ` <img src="${notefileMLA1Base64}" style="object-fit: cover;"  width="660" height="800"/> ` : ''}
                  </div>
                 
                 
                 
                  <div class="page-break">
                    ${notfileCollectorBase64 ? ` <span style="font-size:20px;">Honourable District Collector Message</span> <img src="${notfileCollectorBase64}" style="object-fit: cover;"  width="660" height="800"/> ` : ''}
                  </div>
                 
                 
                  <div class="page-break">
                     ${notfileCollector1Base64 ? ` <img src="${notfileCollector1Base64}" style="object-fit: cover;"  width="660" height="800"/> ` : ''}
                 
                  </div>
                 

                 
                  <h4 class="center">CONTENTS</h4>
                  ${htmlContentind}
                 
               
                 
                  <div> <h4 class="center">1. General Information of the Mandal</h4> <h5 class="left">History, Boundaries and Topography</h5> ${htmlContentgen} </div>
                 
                 
                 
                  <div> ${mandalmapBase64 ? ` <h4>3.2 Mandal Map</h4> <img src="${mandalmapBase64}"   width="660" height="600" /><br/> ` : ''} </div>
                 
                  <div class="page-break"></div>
                 
                  <div class="left"> <h5>Mandal Profile</h5> ${htmlContentmandprof} </div>
                 
                  <div class="page-break"></div>
                 
                  <div class="center"> <h3>2. Economic Perspective</h3> <h5 class="left">Mandal GVA statements – for the year 2022-23</h5> ${tableHTML1} ${htmlContent1} ${tableHTML2} ${htmlContent2} </div>
                 
                  <div class="page-break"></div>
                 
                  <div class="left"> <h3>Pie Chart Report</h3> <img src="${base64Image}" alt="Pie Chart SVG" /> <h4>Sectoral Breakup of Mandal GVA:</h4> <h5>1. Primary Sector (Agriculture & Allied)</h5> <div>${tableHTML3}</div> <div>${htmlContent3}</div> </div>
                 
                  <div class="page-break"></div>
                 
                  <div class="left"> <h4>2. Secondary Sector (Industries)</h4> <div>${tableHTML4}</div> <div>${htmlContent4}</div> </div>
                 
                  <div class="page-break"></div>
                 
                  <div class="left"> <h4>3. Tertiary Sector (Services)</h4> <div>${tableHTML5}</div> <div>${htmlContent5}</div> </div>
                 
                  <div class="page-break"></div>
                 
                  <div class="center"> <h3>3. Mandal Development Vision Plan</h3> </div>
                 
                  <div class="left"> <p>The Mandal Action Plan primarily targets the development of the Primary sector, which includes: Agriculture, Horticulture, Livestock, Fisheries, and Forestry</p> <div>${combinedHTMLmanddev}</div> </div>
                 
                  <div class="page-break"></div>
                 
                  <div class="center">
                    <h4>Way Forward</h4>
                    <div>${htmlContentwayfor}</div>
                  </div>
                </body>
                </html>`;
 
                resolve(docContent);
                const htmlDocx = window.htmlDocx;
                if (!htmlDocx?.asBlob) {
                  ShowAlert("DOCX library failed to load.", "error");
                  return;
                }
                const converted = htmlDocx.asBlob(docContent);
   
                      saveAs(converted, 'document.docx');
            };
            img3.onerror = function () { reject('Failed to load third image.'); };
            img3.src = img3Base64; 
          };

          coverPic2.onerror = function () {
            reject('Failed to load Cover Pic 2.');
          };
          coverPic2.src = coverPic2Base64; 
        };

        coverPic1.onerror = function () {
          reject('Failed to load Cover Pic 1.');
        };
        coverPic1.src = coverPic1Base64; 
      };

      img2.onerror = function () {
        reject('Failed to load second image.');
      };
      img2.src = img2Base64; 
    };

    img1.onerror = function () {
      reject('Failed to load first image.');
    };
    img1.src = img1Base64; 
  };

  img.onerror = function () {
    reject(new Error('Failed to load the image.'));
  };
  img.src = svgBase64; // Load SVG image
} else {
  reject(new Error('Element not found.'));
}
});
};
  


const handleDownloadZip = () => {
  setIsDisabled(true);
  store.dispatch({ type: "SHOW_SPINNER" });
  SwaranandhraService.PdfZip()
  .then((response) => {
    triggerDownload(response.data); 
  }).catch((error) => { console.error("Error downloading ZIP file:", error); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); })
 
};
const triggerDownload = (blob) => {
  const url = window.URL.createObjectURL(new Blob([blob], { type: "application/zip" })); const link = document.createElement("a"); link.href = url; link.setAttribute("download", "All Mandals pdf.zip"); document.body.appendChild(link); link.click(); link.parentNode.removeChild(link); window.URL.revokeObjectURL(url); 
};

 

  const handleSubmit7 = (tabKey, tab) => {
    const htmlContent = editorRefs.current[tabKey]?.value.trim();
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlContent;
    if (htmlContent === `<p><br></p>` || htmlContent === '') { Swal.fire({ icon: "warning", title: "Empty Content", text: "Please enter some content before posting.", }); return; }
    if (tab === 7) {
      let params = { "tab": tab, "userId": username, "distId": district, "mandalId": mandal, "indexPage": htmlContent }
      store.dispatch({ type: "SHOW_SPINNER" });
      SwaranandhraService.getMandalVisionBook(params).then((res) => {
        if (res.data.SCODE === "01") {
          ShowAlert(res.data.SDESC, "success");
          fetchData1();


        } else {
          ShowAlert(res.data.SDESC, "error");
        }
      }).catch((error) => { console.error("Error submitting data:", error); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    }



  };



  const Mandalpdf = (detail) => {
    let params = { "distId": detail.district_code, "mandalId": detail.mandal_code, };
    store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.getgeneratepdf(params).then((res) => {
        if (res.data) {
          const url = window.URL.createObjectURL(
            new Blob([res.data], { type: "application/pdf" })
          );
          let tab = window.open();
          tab.location.href = url;
        }
      }).catch((error) => { console.error("Error:", error); }) .finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };


  useEffect(() => {
    const storedKey = localStorage.getItem("activeTabKey");
    if (storedKey) {
      setKey(storedKey);
    }
  }, []);
const handleTabSelect = (tabKey) => { setKey(tabKey); localStorage.setItem("activeTabKey", tabKey); };


  const Freezfunction = (e, detail, i) => {
    let params = { "status": "bookFreez", "userId": username, "distId": detail.district_code, "mandalId": detail.mandal_code, "bookFreez": parseInt(e.target.value) }
    formik.setFieldValue(`bookfreez[${i}]`, e.target.value);
    store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.getStatusOfMandalVisionBook(params).then((res) => {
      if (res.data.SCODE === "01") {
        ShowAlert(res.data.SDESC, "success")
      } else if (res.data.SCODE === "02") {
        ShowAlert(res.data.SDESC, "success")
      }
    }).finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  }







  const handlePrint = () => {
    const content = document.querySelector('.html-container').innerHTML;

    const blob = new Blob([`
      <html>
        <head>
          <title>Mandal Vision Action Plan</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 0; padding: 20px 10px; }
            .page-border {
              border: 1px solid black;
              padding: 10px 10px;
              margin-bottom: 10px;
              position: relative;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin: 20px 10px;
            }
            th, td {
              border: 1px solid black;
              padding: 8px;
              text-align: left;
            }
            th {
              background-color: #f2f2f2;
            }
  
            @media print {
              @page {
                size: auto;
                margin: 10mm 15mm;
              }
  
              body {
                counter-reset: page;
              }
  
              .page-border::after {
                content: "Page " counter(page);
                counter-increment: page;
                position: absolute;
                bottom: 0;
                right: 0;
                padding: 10px;
                font-size: 12px;
                color: gray;
              }
  
              .page-border {
                page-break-after: always;
              }
            }
          </style>
        </head>
        <body>
          ${content.split('<!-- page break -->').map(section => `
            <div class="page-border">${section}</div>
          `).join('')}
        </body>
      </html>
    `], { type: 'text/html' });

    const iframe = document.createElement('iframe');
    document.body.appendChild(iframe);
    iframe.style.display = 'none';

    const url = URL.createObjectURL(blob);
    iframe.src = url;

    iframe.onload = function () {
      iframe.contentWindow.document.title = "Mandal Vision Action Plan";
      setTimeout(() => { iframe.contentWindow.focus(); iframe.contentWindow.print(); URL.revokeObjectURL(url); document.body.removeChild(iframe); }, 100);
    };
  };

  const Back = () => { setEnb(true); setSubEnb(false); setSubEnb1(false); }


  const filteredDataStatus =
    searchTextStatus.length > 0 ? statusData?.filter((item) => {
      return (
        item &&
        Object.keys(item).some((key) => { const value = item[key]; return (value !== null && value.toString().toLowerCase().includes(searchTextStatus.toLowerCase())); })
      );
    }) : statusData;


  const districtdata = (e) => {
    formik.setFieldValue("district_id", e.target.value)
    let params = { "distId": e.target.value, "userId": username, "status": "bookStatus"}
    if ((roleid === "5" || roleid === "8") && (e.target.value !== "" || null)) {
      SwaranandhraService.getStatusOfMandalVisionBook(params).then((res) => {
        if (res.data.SCODE === "01") {
          setStatusData(res.data.SDESC)
          res.data.SDESC.forEach((item, index) => { formik.setFieldValue(`bookfreez[${index}]`, item.book_freez || ""); });
        }
      });
    }
  }



  return (
    <>
      <Menubar />

      <Container fluid className='map-header mx-2'> <div className='sa-title'> <h2>Mandal Vision Action <span>Plan</span></h2> </div> </Container>

      <Container fluid className='mt-5' >
        <FormikProvider value={formik} >
          <Form onSubmit={formik.handleSubmit}>
            <div className='mandal-container p-4'>
              <Row>
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'>
                  <h5>District</h5>
                  <Field className="mb-3 form-control" component="select" name="district_id" controlId="formBasicEmail" disabled={distEnb} style={{ fontWeight: "bold" }} onChange={(e) => { districtdata(e) }}> <option value="">--Select--</option> {distlist} </Field>

                </Col>
                {roleid === "3" ?
                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select'>
                    <h5>Mandal</h5>
                    <Field className="mb-3 form-control" component="select" name="mandal_id" controlId="formBasicEmail" disabled={manEnb} style={{ fontWeight: "bold" }}> <option value="">--Select--</option> {mandallist} </Field>

                  </Col>
                  : null}
                    {(roleid==="5")|| (roleid==="8")?
                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mt-4'>
                  <Button  disabled={isDisabled} className="btn btn-danger" onClick={() => handleDownloadZip()}   > All Mandals pdf <MdOutlinePictureAsPdf /> </Button>
                        </Col>: null}

              </Row>
            </div>
          </Form>
        </FormikProvider>
      </Container>

      {enb && <>
        {roleid === "3" && <Container className="outer-page-content-container" style={{ marginBottom: "50px" }} fluid >
          <FormikProvider value={formik} >
            <Form onSubmit={formik.handleSubmit}>

              <Tabs id="editor-tabs" activeKey={key} onSelect={handleTabSelect} style={{ border: "1px solid #dee2e6", borderRadius: "10px", marginBottom: "20px", width: "fit-content", background: "#f8f9fa", boxShadow: "0 8px 18px rgba(0, 0, 0, 0.1)", fontFamily: "Arial, sans-serif", }} className="custom-tabs" >


                <Tab eventKey="coverpage" title="1-Cover Page" className="" fluid style={{ width: "80%" }} >
                  <>
                    <Container className="p-4" style={{ width: "100%" }}>

                      <Row> <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12} className="mb-3 list-right" >
                          <div className="mb-4">
                            <h6 className="fw-bold">1. Cover Page Images</h6>
                            <DESUI.Row className="mt-2" > 
                              <DESUI.Col xs={12} sm={12} md={3} lg={6} xl={6} xxl={6}>
                                <label className="mb-1" htmlFor="coverpic1">Cover Pic 1</label> <span style={{ color: "red" }}> *</span>
                                <div className="d-flex">
                                  <input  id="coverpic1" type="file" className="form-control" name="coverpic1" onChange={(event) => handleFileUpload(event)} />
                                  {formik.values.coverpic1 && ( <img src={formik.values.coverpic1} alt="Cover Pic 1" className="form-control" style={{ width: '50px', height: '40px', }} /> )}
                                </div>
                                <span style={{ color: "red", fontSize: "13px" }}> {fileErrors.coverpic1 && <div style={{ color: 'red', fontSize: '13px' }}>{fileErrors.coverpic1}</div>} </span>
                              </DESUI.Col>
                              <DESUI.Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                                <label className="mb-1 " htmlFor="coverpic2">Cover Pic 2</label> <span style={{ color: "red" }}> *</span>
                                <div className="d-flex">
                                  <input  id="coverpic2" type="file" className="form-control" name="coverpic2" onChange={(event) => handleFileUpload(event)} />
                                  {formik.values.coverpic2 && ( <img src={formik.values.coverpic2} alt="Cover Pic 2" className="form-control" style={{ width: '50px', height: '40px', }} /> )}
                                </div>
                                <span style={{ color: "red", fontSize: "13px" }}> {fileErrors.coverpic2 && <div style={{ color: 'red', fontSize: '13px' }}>{fileErrors.coverpic2}</div>} </span>
                              </DESUI.Col>
                            </DESUI.Row>
                          </div>


                          <div className="mb-4">
                            <h6 className="fw-bold">2. Honourable Minister Message</h6>
                            <DESUI.Row className="mt-2 ">
                              <DESUI.Col xs={12} sm={12} md={3} lg={6} xl={6} xxl={6}  >
                                <label className="mb-1" htmlFor="notefilemla">2.1 Honourable Minister Message</label>
                                <div className="d-flex">
                                  <input id="notefilemla" type="file" className="form-control" name="notefilemla" onChange={(event) => handleFileUpload(event)} />
                                  {formik.values.notefilemla && ( <img src={formik.values.notefilemla} alt="Honourable Minister Message" className="form-control" style={{ width: '50px', height: '40px', }} /> )}
                                </div>
                                <span style={{ color: "red", fontSize: "13px" }}> {fileErrors.notefilemla && <div style={{ color: 'red', fontSize: '13px' }}>{fileErrors.notefilemla}</div>} </span>
                              </DESUI.Col>

                              <DESUI.Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} >
                                <label className="mb-1" htmlFor="notefilemla1">2.2 Honourable Minister Message (optional)</label>
                                <div className="d-flex"> <input id="notefilemla1" type="file" className="form-control" name="notefilemla1" onChange={(event) => handleFileUpload(event)} /> {formik.values.notefilemla1 && ( <img src={formik.values.notefilemla1} alt="Honourable Minister Message" className="form-control" style={{ width: '50px', height: '40px', }} /> )} </div>
                                <span style={{ color: "red", fontSize: "13px" }}> {fileErrors.notefilemla1 && <div style={{ color: 'red', fontSize: '13px' }}>{fileErrors.notefilemla1}</div>} </span>
                              </DESUI.Col>
                            </DESUI.Row>
                          </div>

                          <div className="mb-4">
                            <label className="fw-bold">3. District Collector Message</label>
                            <DESUI.Row className="mt-2 ">
                              <DESUI.Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                                <label className="mb-1" htmlFor="notfilecollecter">3.1 Honourable District Collector Message</label><span style={{ color: "red" }}> *</span>
                                <div className="d-flex"> <input id="notfilecollecter"type="file" className="form-control" name="notfilecollecter" onChange={(event) => handleFileUpload(event)} /> {formik.values.notfilecollecter && ( <img src={formik.values.notfilecollecter} alt="Honourable District Collector Message" className="form-control" style={{ width: '50px', height: '40px', }} /> )} </div>
                                <span style={{ color: "red", fontSize: "13px" }}> {fileErrors.notfilecollecter && <div style={{ color: 'red', fontSize: '13px' }}>{fileErrors.notfilecollecter}</div>} </span>
                              </DESUI.Col>

                              <DESUI.Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                                <label className="mb-1" htmlFor="notecollectorPic1">3.2 Honourable District Collector Message (optional)</label>
                                <div className="d-flex"> <input id="notecollectorPic1"type="file" className="form-control" name="notecollectorPic1" onChange={(event) => handleFileUpload(event)} /> {formik.values.notecollectorPic1 && ( <img src={formik.values.notecollectorPic1} alt="Honourable District Collector Message (optional)" className="form-control" style={{ width: '50px', height: '40px', }} /> )} </div>
                                <span style={{ color: "red", fontSize: "13px" }}> {fileErrors.notecollectorPic1 && <div style={{ color: 'red', fontSize: '13px' }}>{fileErrors.notecollectorPic1}</div>} </span>
                              </DESUI.Col>
                            </DESUI.Row>
                          </div>
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12} className="mb-3 list-left" >
                          <div className="sa-list" >
                            <h4 style={{ color: "red" }}>Note :</h4>
                            <ListGroup style={{ marginTop: "20px" }}> <ListGroup.Item style={{ color: "red" }}> Cover Page Images, Honourable Minister Images, District Collector  Images Size Must below 500KB </ListGroup.Item> </ListGroup>
                            <ListGroup style={{ marginTop: "20px" }}> <ListGroup.Item style={{ color: "red" }}> All Images Format Must be JPEG or PNG . </ListGroup.Item> </ListGroup>
                          </div>
                        </Col>
                      </Row>
                    </Container>

                    <div className="d-flex justify-content-center bottom-buttons">
                      <Button onClick={() => Preview2()} style={{ marginTop: "20px" }} size="sm" className="next-btn me-4" >
                        Preview <FaEye className="ms-1 s-icon" />
                      </Button>
                      
                      {bookfreez === "2" && <Button onClick={() => handleSubmit("coverpage", 1)} style={{ marginTop: "20px" }} size="sm" className="save-btn me-4" > Save <FaRegSave className="ms-1 s-icon" /> </Button>}
                      <Button onClick={() => setKey("generalinfo")} style={{ marginTop: "20px" }} size="sm" className="save-btn" > Next <FaArrowRightLong className="ms-1 n-icon" /> </Button>

                    </div>


                  </>
                </Tab>




                <Tab eventKey="generalinfo" title="2-General Info" className="">

                  <Container>
                    <div className='sa-title'> <h4 className="fw-bold">1. General Information of the Mandal, History, Boundaries  and Topography</h4> <p >1.1 History, Boundaries  and Topography </p> </div>

                    <JoditEditor ref={(el) => (editorRefs.current["generalinfo"] = el)} value={generalinfo || ""} config={configEditor} tabIndex={1} />
                    <div className="d-flex justify-content-center bottom-buttons">
                      <Button onClick={() => Preview3()} style={{ marginTop: "20px" }} size="sm" className="next-btn me-4" > Preview <FaEye className="ms-1 s-icon" /> </Button>
{bookfreez === "2" && <Button onClick={() => handleSubmit1("generalinfo", 2)} style={{ marginTop: "20px" }} size="sm" className="save-btn  me-4" > Save <FaRegSave className="ms-1 s-icon" /> </Button>}

                      <Button onClick={() => setKey("mandaldetails")} style={{ marginTop: "20px" }} size="sm" className="save-btn me-4" > Next <FaArrowRightLong className="ms-1 n-icon" /> </Button>
                    </div>
                  </Container>

                  <Modal fade={false} aria-labelledby="contained-modal-title-vcenter" className="newmodal" centered show={addModal3} size="xl">
                    <Modal.Header >
                      <Modal.Title className="text-center">General Info</Modal.Title>
                    
<span role="button" tabIndex="0" onClick={handleClose3} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleClose3(); } }} style={{ cursor: "pointer" }} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "white")} aria-label="Close" > &#215; </span>

                    </Modal.Header>
                    <Modal.Body className="p-5"> <div className="html-container" > </div> <div className="d-flex justify-content-end"> <button className="btn btn-danger" onClick={() => { setAddModal3(false); }} type="button"><RiCloseCircleLine />  Close</button> </div> </Modal.Body>
                  </Modal>

                </Tab>


                <Tab eventKey="mandaldetails" title="3-Mandal Details" className="">

                  <Container  >
                    <div className='sa-title'>
                      <h4 className="fw-bold">Mandal Map & Mandal Profile</h4>
                    </div>
                    <div className="mb-3">
                      <label><h6 style={{ fontWeight: "bold" }}>1.1 Mandal Map</h6></label> <span style={{ color: "red" }}> *</span>

                      <DESUI.Row className="mt-2">
                        <DESUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mx-3">
                          <div className="d-flex"> <input type="file" name="mandalmap" className="form-control" onChange={(event) => handleFileUpload(event)} /> {formik.values.mandalmap && ( <img src={formik.values.mandalmap} alt="Mandal Map" className="form-control" style={{ width: '50px', height: '40px' }} /> )} </div>
                          <span style={{ color: "red", fontSize: "13px" }}> {fileErrors.mandalmap && <div style={{ color: 'red', fontSize: '13px' }}>{fileErrors.mandalmap}</div>} </span>
                        </DESUI.Col>
                      </DESUI.Row>
                    </div>

                    <h6 style={{ fontWeight: "bold" }}>1.2 Mandal Profile</h6>

                    <JoditEditor ref={(el) => (editorRefs.current["mandaldetails"] = el)} value={mandalprofile || ""} config={configEditor} tabIndex={1} />
                    <div className="d-flex justify-content-center bottom-buttons">
                      <Button onClick={() => Preview4()} style={{ marginTop: "20px" }} size="sm" className="next-btn me-4" > Preview <FaEye className="ms-1 s-icon" /> </Button>
                      {bookfreez === "2" && <Button variant="" size="sm" className="save-btn me-4" onClick={() => handleSubmit2("mandaldetails", 3)} style={{ marginTop: "20px" }}> Save <FaRegSave className="ms-1 s-icon" /> </Button>}
                      <Button onClick={() => setKey("economic")} style={{ marginTop: "20px" }} size="sm" className="save-btn me-4" > Next <FaArrowRightLong className="ms-1 n-icon" /> </Button>
                    </div>
                  </Container>

                  <Modal fade={false} aria-labelledby="contained-modal-title-vcenter" className="newmodal" centered show={addModal4} size="xl">
                    <Modal.Header >
                      <Modal.Title className="text-center">Mandal Details</Modal.Title>
 <span role="button" tabIndex="0" aria-label="Close" onClick={handleClose4} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClose4(); } }} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "white")} style={{ cursor: "pointer" }} > &#215; </span>

                    </Modal.Header>
                    <Modal.Body className="p-5">
                      <div className="html-container" >


                      </div>
                      <div className="d-flex justify-content-end"> <button className="btn btn-danger" onClick={() => { setAddModal4(false); }} type="button" style={{ borderRadius: "20px" }}><RiCloseCircleLine />  Close</button> </div>
                    </Modal.Body>
                  </Modal>
                </Tab>







                <Tab eventKey="economic" title="4-Economic Perspective" >

                  <div className='sa-title'>
                    <h4 className="fw-bold">Mandal GVA statements – for the year 2022-23 </h4>
                  </div>

                  <Container className="d-flex" fluid style={{ width: "100%" }}>
                    <Row fluid style={{ width: "100%" }}>
                      <Col xs={12} sm={12} lg={12} md={12} xl={7} xxl={7}>
                        <DESUI.Table bordered hover id="my-table" className="table custom-table table-responsive">
                          <thead>
                            <tr><th colSpan={5}>Gross Mandal Domestic Product Details</th></tr>
                            <tr className="text-center"> <th rowSpan={2} style={{ textAlign: "center" }}>Sl.No.</th> <th rowSpan={2} style={{ textAlign: "center" }}>BROAD SECTOR</th> <th rowSpan={2} style={{ textAlign: "center" }}>SUB SECTOR</th> <th colSpan={2} style={{ textAlign: "center" }}>2022-23</th> </tr>
                            <tr> <th style={{ textAlign: "center" }}>GVA<br />(Rs. In Lakhs)</th> <th style={{ textAlign: "center" }}>Contribution (%)</th> </tr>
                          </thead>
                          <tbody>
                            {data?.length === 0 ||
                              data?.length === undefined ? (
                              <tr> <td colSpan={5} style={{ color: "red", textAlign: "center" }}>Details Not Found</td> </tr>
                            ) : (
                              (() => {
                                let previousSector = null;
                                return data?.map((detail, i) => {

                                  const isValidSector = detail.sector_name && detail.sector_name.trim() !== "";
                                  const showSectorName = isValidSector && detail.sector_name !== previousSector;

                                  if (isValidSector) {
                                    previousSector = detail.sector_name;
                                  }

                                  return (
                                    <tr key={i}>
                                      <td style={{ textAlign: "center" }}>{i + 1}</td> <td style={{ textAlign: "left" }} > {showSectorName && detail.sector_name} </td> <td style={{ textAlign: "left" }}>{detail.industry_name}</td> <td style={{ textAlign: "right" }}>{detail.gmdp}</td>
                                      {detail.is_data_entry ? <td style={{ textAlign: "right" }}>{detail.contribution}</td> : (detail.industry_id === 22 && detail.gmdp !== 0) ? <td style={{ textAlign: "right" }}>100</td> : null }
                                    </tr>
                                  );
                                });
                              })()
                            )}
                          </tbody>
                        </DESUI.Table>
                      </Col>

                      <Col xs={12} sm={12} lg={12} md={12} xl={5} xxl={5} className="agr-secto">
                        <JoditEditor ref={(el) => (editorRefs.current["economic"] = el)} value={economictext1 || ""} config={configEditor} tabIndex={1} />

                      </Col>
                    </Row>
                  </Container>





                  <Container className="d-flex" fluid style={{ width: "100%", marginTop: '10px' }}>
                    <Row fluid style={{ width: "100%" }}>
                      <Col xs={12} sm={12} lg={12} md={12} xl={7} xxl={7}>
                        <DESUI.Table bordered hover id="my-table1" className="table custom-table table-responsive">
                          <thead>
                            <tr className="text-center"> <th style={{ textAlign: "center" }}>Sl.No.</th> <th style={{ textAlign: "center" }}>Sector</th> <th style={{ textAlign: "center" }}>GVA (Rs.in Lakhs) </th> <th style={{ textAlign: "center" }}>Contribution (%)</th> </tr>

                          </thead>
                          <tbody>
                            {data1?.length === 0 ||
                              data1?.length === undefined ? (
                              <tr> <td colSpan={4} style={{ color: "red", textAlign: "center" }}>Details Not Found</td> </tr>
                            ) : (
                              (() => {
                                return data1?.map((detail, i) => {
                                  return (
                                    <tr key={i}> <td style={{ textAlign: "center" }}>{i + 1}</td> <td style={{ textAlign: "left" }} >{detail.bs_name}</td> <td style={{ textAlign: "right" }} >{detail.gmdp}</td> <td style={{ textAlign: "right" }}>{detail.contribution}</td> </tr>
                                  );
                                });
                              })()
                            )}
                          </tbody>
                        </DESUI.Table>

                        <div className="d-flex justify-content-center" id="my-table1pie">
                          <PieChart width={400} height={350}>
                            <Pie data={pieChartData} cx={200} cy={100} cz={200} outerRadius={80} fill="#8884d8" dataKey="value" paddingAngle={3} >
                              {pieChartData?.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color} strokeWidth={0}  />
                              ))}
                              <LabelList dataKey="gmdp" fontSize={17} fontWeight="bold" stroke="white" fill="black" position="outside" formatter={(value) => `${value} Lakhs`} />
                            </Pie>
                            <Tooltip />
                          </PieChart>
                          <div>
                            {pieChartData?.map((entry, index) => (
                              <div key={index} style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}> <div style={{ width: '20px', height: '20px', backgroundColor: entry.color, marginRight: '10px', }} ></div> <span>{entry.name}</span> </div>
                            ))}
                          </div>
                        </div>
 


                      </Col>

                      <Col xs={12} sm={12} lg={12} md={12} xl={5} xxl={5} className="agr-secto">
                        <JoditEditor ref={(el) => (editorRefs.current["economic1"] = el)} value={economictext2 || ""} config={configEditor} tabIndex={1} />

                      </Col>
                    </Row>
                  </Container>




                  <div className='sa-title'> <h4 className="fw-bold" >Sectoral Breakup of Mandal GVA:</h4> <p>1.	Primary Sector (Agriculture & Allied) :</p> </div>
                  <Container className="d-flex" fluid style={{ width: "100%", marginTop: '10px' }}>
                    <Row fluid style={{ width: "100%" }}>
                      <Col xs={12} sm={12} lg={12} md={12} xl={7} xxl={7}>
                        <DESUI.Table bordered hover id="my-table2" className="table custom-table table-responsive">
                          <thead>
                            <tr className="text-center"> <th  style={{ textAlign: "center" }}>Sl.No.</th> <th  style={{ textAlign: "center" }}>Sub-Sector</th> <th  style={{ textAlign: "center" }}>GVA (Rs.in Lakhs) </th> <th style={{ textAlign: "center" }} >Contribution (%)</th> </tr>

                          </thead>
                          <tbody>
                            {data2?.length === 0 ||
                              data2?.length === undefined ? (
                              <tr> <td colSpan={3} style={{ color: "red", textAlign: "center" }}>Details Not Found</td> </tr>
                            ) : (
                              (() => {

                                return data2?.map((detail, i) => {
                                  return (
                                    <tr key={i}> <td style={{ textAlign: "center" }}>{i + 1}</td> <td style={{ textAlign: "left" }} >{detail.industry_name}</td> <td style={{ textAlign: "right" }} >{detail.gmdp}</td> <td style={{ textAlign: "right" }} >{detail.contribution}</td> </tr>
                                  );
                                });
                              })()
                            )}



                          </tbody>


                          {data2.length > 0 ? <tfoot style={{ position: "sticky", bottom: "0px" }} className="text-right">
                            <tr className="table_countshead">
                              <td colSpan={2} className="text-center" style={{ fontWeight: "bold", textAlign: "center" }}>
                                Totals
                              </td>
                              <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                {data2
                                  ?.reduce((total, detail) => total + (isNaN(detail.gmdp) ? 0 : detail.gmdp ?? 0), 0)
                                  .toFixed(2)}
                              </td>
                              <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                {data2
                                  ?.reduce((total, detail) => total + (isNaN(detail.contribution) ? 0 : detail.contribution ?? 0), 0)
                                  .toFixed(2)}
                              </td>
                            </tr>
                          </tfoot> : null}
                        </DESUI.Table>
                      </Col>

                      <Col xs={12} sm={12} lg={12} md={12} xl={5} xxl={5} className="agr-secto"> <JoditEditor ref={(el) => (editorRefs.current["economic2"] = el)} value={primarytext || ""} config={configEditor} tabIndex={1} /> </Col>
                    </Row>
                  </Container>



                  <div className='sa-title'> <p>2.	Secondary Sector (Industries): </p> </div>
                  <Container className="d-flex" fluid style={{ width: "100%", marginTop: '10px' }}>
                    <Row fluid style={{ width: "100%" }}>
                      <Col xs={12} sm={12} lg={12} md={12} xl={7} xxl={7}>
                        <DESUI.Table bordered hover id="my-table3" className="table custom-table table-responsive">
                          <thead>
                            <tr className="text-center"> <th style={{ textAlign: "center" }}>Sl.No.</th> <th  style={{ textAlign: "center" }}>Sub-Sector</th> <th  style={{ textAlign: "center" }}>GVA (Rs.in Lakhs) </th> <th style={{ textAlign: "center" }}>Contribution (%)</th> </tr>

                          </thead>
                          <tbody>
                            {data3?.length === 0 ||
                              data3?.length === undefined ? (
                              <tr> <td colSpan={3} style={{ color: "red", textAlign: "center" }}>Details Not Found</td> </tr>
                            ) : (
                              (() => {

                                return data3?.map((detail, i) => { return ( <tr key={i}> <td style={{ textAlign: "center" }}>{i + 1}</td> <td style={{ textAlign: "left" }} >{detail.industry_name}</td> <td style={{ textAlign: "right" }}>{detail.gmdp}</td> <td style={{ textAlign: "right" }} >{detail.contribution}</td> </tr> ); });
                              })()
                            )}



                          </tbody>
                          {data3.length > 0 ? <tfoot style={{ position: "sticky", bottom: "0px" }} className="text-right">
                            <tr className="table_countshead">
                              <td colSpan={2} style={{ fontWeight: "bold", textAlign: "center" }}>
                                Totals
                              </td>
                              <td style={{ fontWeight: "bold", textAlign: "right" }}>
                                {data3
                                  ?.reduce((total, detail) => total + (isNaN(detail.gmdp) ? 0 : detail.gmdp ?? 0), 0)
                                  .toFixed(2)}
                              </td>
                              <td style={{ fontWeight: "bold", textAlign: "right" }}>
                                {data3
                                  ?.reduce((total, detail) => total + (isNaN(detail.contribution) ? 0 : detail.contribution ?? 0), 0)
                                  .toFixed(2)}
                              </td>
                            </tr>
                          </tfoot> : null}
                        </DESUI.Table>
                      </Col>
<Col xs={12} sm={12} lg={12} md={12} xl={5} xxl={5} className="agr-secto"> <JoditEditor ref={(el) => (editorRefs.current["economic3"] = el)} value={industrytext || ""} config={configEditor} tabIndex={1} /> </Col>
                    </Row>
                  </Container>




                  <div className='sa-title'>

                    <p>3.	Tertiary Sector (Services):  </p>
                  </div>
                  <Container className="d-flex" fluid style={{ width: "100%", marginTop: '10px' }}>
                    <Row fluid style={{ width: "100%" }}>
                      <Col xs={12} sm={12} lg={12} md={12} xl={7} xxl={7}>
                        <DESUI.Table bordered hover id="my-table4" className="table custom-table table-responsive">
                          <thead>
                            <tr className="text-center"> <th style={{ textAlign: "center" }}>Sl.No.</th> <th style={{ textAlign: "center" }}>Sub-Sector</th> <th style={{ textAlign: "center" }}>GVA (Rs.in Lakhs) </th> <th style={{ textAlign: "center" }}>Contribution (%)</th> </tr>

                          </thead>
                          <tbody>
                            {data4?.length === 0 ||
                              data4?.length === undefined ? (
                              <tr> <td colSpan={3} style={{ color: "red", textAlign: "center" }}>Details Not Found</td> </tr>
                            ) : (
                              (() => {

                                return data4?.map((detail, i) => {
                                  return (
                                    <tr key={i}> <td style={{ textAlign: "center" }}>{i + 1}</td> <td style={{ textAlign: "left" }}  >{detail.industry_name}</td> <td style={{ textAlign: "right" }}>{detail.gmdp}</td> <td style={{ textAlign: "right" }} >{detail.contribution}</td> </tr>
                                  );
                                });
                              })()
                            )}
                          </tbody>
                          {data4.length > 0 ? <tfoot style={{ position: "sticky", bottom: "0px" }} className="text-right">
                            <tr className="table_countshead">
                              <td colSpan={2} style={{ fontWeight: "bold", textAlign: "center" }}>
                                Totals
                              </td>
                              <td style={{ fontWeight: "bold", textAlign: "right" }}>
                                {data4
                                  ?.reduce((total, detail) => total + (isNaN(detail.gmdp) ? 0 : detail.gmdp ?? 0), 0)
                                  .toFixed(2)}
                              </td>
                              <td style={{ fontWeight: "bold", textAlign: "right" }}>
                                {data4
                                  ?.reduce((total, detail) => total + (isNaN(detail.contribution) ? 0 : detail.contribution ?? 0), 0)
                                  .toFixed(2)}
                              </td>
                            </tr>
                          </tfoot> : null}
                        </DESUI.Table>
                      </Col>

                      <Col xs={12} sm={12} lg={12} md={12} xl={5} xxl={5} className="agr-secto"> <JoditEditor ref={(el) => (editorRefs.current["economic4"] = el)} value={servicetext || ""} config={configEditor} tabIndex={1} /> </Col>
                    </Row>
                  </Container>





                  <div className="d-flex justify-content-center bottom-buttons">
                    <Button onClick={() => Preview()} style={{ marginTop: "20px" }} size="sm" className="next-btn me-4" > Preview  <FaEye className="ms-1 s-icon" /> </Button> {bookfreez === "2" && <Button onClick={() => handleSubmit3("economic", 4)} style={{ marginTop: "20px" }} size="sm" className="save-btn  me-4" > Save <FaRegSave className="ms-1 s-icon" /> </Button>} <Button onClick={() => setKey("mandaldevelopment")} style={{ marginTop: "20px" }} size="sm" className="save-btn me-4" > Next <FaArrowRightLong className="ms-1 n-icon" /> </Button>
                  </div>




                </Tab>
                <Tab eventKey="mandaldevelopment" title="5-Mandal Development Vision Plan">
                  <div className='sa-title'>
                    <h4 className="fw-bold">The Mandal Action Plan primarily targets the development of the Primary sector, which includes:</h4>
                    <p>Agriculture, Horticulture, Livestock, Fisheries, and Forestry</p>
                  </div>

                  <Container className="d-flex flex-column " fluid style={{ width: "100%" }}>

                    <Row fluid className="mb-4" style={{ width: "75%" }} >
                      <h4>Agriculture Sector</h4>
                      <DESUI.Table bordered hover id="my-table5" className="table custom-table table-responsive">
                        <thead>
                          <tr className="text-center"> <th rowSpan={2} style={{ fontSize: "12px" }} >Sl.No.</th> <th rowSpan={2} style={{ fontSize: "12px" }}>INDICATOR</th> <th rowSpan={2} style={{ fontSize: "12px" }}>UNIT</th> <th colSpan={1} style={{ fontSize: "12px" }}>ANNUAL<br /> ACHIEVEMENTS</th> <th colSpan={5} style={{ fontSize: "12px" }}>ANNUAL TARGETS</th> <th rowSpan={2} style={{ fontSize: "12px" }}>Indicative Financial Plan - Expected sources of<br /> funding (CSS, State Plan, NGOs,<br /> CSR Contributions, etc.)</th> </tr>
                          <tr> <th style={{ fontSize: "12px" }}>2023-24</th> <th style={{ fontSize: "12px" }}>2024-25</th> <th style={{ fontSize: "12px" }}>2025-26</th> <th style={{ fontSize: "12px" }}>2026-27</th> <th style={{ fontSize: "12px" }}>2027-28</th> <th style={{ fontSize: "12px" }}>2028-29</th> </tr>
                        </thead>
                        <tbody>
                          {data5?.length === 0 || data5?.length === undefined ? (
                            <tr>
                              <td colSpan={11} className="text-center" style={{ color: "red" }}>Details Not Found</td>
                            </tr>
                          ) : (
                            data5?.map((detail, i) => (
                              <tr key={i}> <td style={{ textAlign: "center", fontSize: "11px " }}>{i + 1}</td> <td style={{ fontSize: "11px ", textAlign: "left" }}>{detail.sub_indicator_name}</td> <td style={{ textAlign: "left", fontSize: "11px" }}>{detail.unit}</td> <td style={{ textAlign: "right", fontSize: "11px" }}>{detail.achived}</td> <td style={{ textAlign: "right", fontSize: "11px" }}>{detail.target_2024_2025}</td> <td style={{ textAlign: "right", fontSize: "11px" }}>{detail.target_2025_2026}</td> <td style={{ textAlign: "right", fontSize: "11px" }}>{detail.target_2026_2027}</td> <td style={{ textAlign: "right", fontSize: "11px" }}>{detail.target_2027_2028}</td> <td style={{ textAlign: "right", fontSize: "11px" }}>{detail.target_2028_2029}</td> <td style={{ textAlign: "center", fontSize: "11px" }}>{detail.source_of_funding}</td> </tr>
                            ))
                          )}
                        </tbody>
                      </DESUI.Table>
                    </Row>

                    <Row fluid className="mb-4" style={{ width: "75%" }}>
                      <h4>Horticulture Sector</h4>
                      <Col xs={12}>
                        <DESUI.Table bordered hover id="my-table51" className="table custom-table table-responsive">
                          <thead>
                            <tr className="text-center"> <th rowSpan={2} style={{ fontSize: "12px" }}>Sl.No.</th> <th rowSpan={2} style={{ fontSize: "12px" }}>INDICATOR</th> <th rowSpan={2} style={{ fontSize: "12px" }}>UNIT</th> <th colSpan={1} style={{ fontSize: "12px" }}>ANNUAL ACHIEVEMENTS</th> <th colSpan={5} style={{ fontSize: "12px" }}>ANNUAL TARGETS</th> <th rowSpan={2} style={{ fontSize: "12px" }}>Indicative Financial Plan -Expected sources of <br />funding (CSS, State Plan, NGOs,<br /> CSR Contributions, etc.)</th> </tr>
                            <tr> <th style={{ fontSize: "12px" }}>2023-24</th> <th style={{ fontSize: "12px" }}>2024-25</th> <th style={{ fontSize: "12px" }}>2025-26</th> <th style={{ fontSize: "12px" }}>2026-27</th> <th style={{ fontSize: "12px" }}>2027-28</th> <th style={{ fontSize: "12px" }}>2028-29</th> </tr>
                          </thead>
                          <tbody>
                            {data51?.length === 0 || data51?.length === undefined ? (
                              <tr>
                                <td colSpan={11} className="text-center" style={{ color: "red" }}>Details Not Found</td>
                              </tr>
                            ) : (
                              data51?.map((detail, i) => (
                                <tr key={i}> <td style={{ fontSize: "11px", textAlign: "center" }} >{i + 1}</td> <td style={{ fontSize: "11px", textAlign: "left" }}>{detail.sub_indicator_name}</td> <td style={{ fontSize: "11px", textAlign: "left" }}>{detail.unit}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.achived}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2024_2025}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2025_2026}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2026_2027}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2027_2028}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2028_2029}</td> <td style={{ fontSize: "11px", textAlign: "center" }}>{detail.source_of_funding}</td> </tr>
                              ))
                            )}
                          </tbody>
                        </DESUI.Table>
                      </Col>
                    </Row>


                    <Row fluid className="mb-4" style={{ width: "75%" }}>
                      <h4>Livestock Sector</h4>
                      <Col xs={12}>
                        <DESUI.Table bordered hover id="my-table52" className="table custom-table table-responsive">
                          <thead>
                            <tr className="text-center"> <th rowSpan={2} style={{ fontSize: "12px" }}>Sl.No.</th> <th rowSpan={2} style={{ fontSize: "12px" }}>INDICATOR</th> <th rowSpan={2} style={{ fontSize: "12px" }}>UNIT</th> <th colSpan={1} style={{ fontSize: "12px" }}>ANNUAL ACHIEVEMENTS</th> <th colSpan={5} style={{ fontSize: "12px" }}>ANNUAL TARGETS</th> <th rowSpan={2} style={{ fontSize: "12px" }}>Indicative Financial  Plan - Expected sources of<br /> funding (CSS, State Plan, NGOs,<br /> CSR Contributions, etc.)</th> </tr>
                            <tr> <th style={{ fontSize: "12px" }}>2023-24</th> <th style={{ fontSize: "12px" }}>2024-25</th> <th style={{ fontSize: "12px" }}>2025-26</th> <th style={{ fontSize: "12px" }}>2026-27</th> <th style={{ fontSize: "12px" }}>2027-28</th> <th style={{ fontSize: "12px" }}>2028-29</th> </tr>
                          </thead>
                          <tbody>
                            {data52?.length === 0 || data52?.length === undefined ? (
                              <tr>
                                <td colSpan={11} className="text-center" style={{ color: "red" }}>Details Not Found</td>
                              </tr>
                            ) : (
                              data52?.map((detail, i) => (
                                <tr key={i}> <td style={{ fontSize: "11px", textAlign: "center" }}>{i + 1}</td> <td style={{ fontSize: "11px", textAlign: "left" }}>{detail.sub_indicator_name}</td> <td style={{ fontSize: "11px", textAlign: "left" }}>{detail.unit}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.achived}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2024_2025}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2025_2026}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2026_2027}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2027_2028}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2028_2029}</td> <td style={{ fontSize: "11px", textAlign: "center" }}>{detail.source_of_funding}</td> </tr>
                              ))
                            )}
                          </tbody>
                        </DESUI.Table>
                      </Col>
                    </Row>

                    <Row fluid className="mb-4" style={{ width: "75%" }}>
                      <h4>Fisheries Sector</h4>
                      <Col xs={12}>
                        <DESUI.Table bordered hover id="my-table53" className="table custom-table table-responsive" >
                          <thead>
                            <tr className="text-center"> <th rowSpan={2} style={{ fontSize: "12px" }}>Sl.No.</th> <th rowSpan={2} style={{ fontSize: "12px" }}>INDICATOR</th> <th rowSpan={2} style={{ fontSize: "12px" }}>UNIT</th> <th colSpan={1} style={{ fontSize: "12px" }}>ANNUAL ACHIEVEMENTS</th> <th colSpan={5} style={{ fontSize: "12px" }}>ANNUAL TARGETS</th> <th rowSpan={2} style={{ fontSize: "12px" }}>Indicative Financial Plan - Expected sources of<br /> funding (CSS, State Plan, NGOs,<br /> CSR Contributions, etc.)</th> </tr>
                            <tr> <th style={{ fontSize: "12px" }}>2023-24</th> <th style={{ fontSize: "12px" }}>2024-25</th> <th style={{ fontSize: "12px" }}>2025-26</th> <th style={{ fontSize: "12px" }}>2026-27</th> <th style={{ fontSize: "12px" }}>2027-28</th> <th style={{ fontSize: "12px" }}>2028-29</th> </tr>
                          </thead>
                          <tbody>
                            {data53?.length === 0 || data53?.length === undefined ? (
                              <tr>
                                <td colSpan={11} className="text-center" style={{ color: "red" }}>Details Not Found</td>
                              </tr>
                            ) : (
                              data53?.map((detail, i) => (
                                <tr key={i}> <td style={{ fontSize: "11px", textAlign: "center" }}>{i + 1}</td> <td style={{ fontSize: "11px", textAlign: "left" }}>{detail.sub_indicator_name}</td> <td style={{ fontSize: "11px", textAlign: "left" }}>{detail.unit}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.achived}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2024_2025}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2025_2026}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2026_2027}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2027_2028}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2028_2029}</td> <td style={{ fontSize: "11px", textAlign: "center" }}>{detail.source_of_funding}</td> </tr>
                              ))
                            )}
                          </tbody>
                        </DESUI.Table>
                      </Col>
                    </Row>

                    <Row fluid className="mb-4" style={{ width: "75%" }}>
                      <h4>Forest Sector</h4>
                      <Col xs={12}>
                        <DESUI.Table bordered hover id="my-table54" className="table custom-table table-responsive">
                          <thead> <tr className="text-center"> <th rowSpan={2} style={{ fontSize: "12px" }}>Sl.No.</th> <th rowSpan={2} style={{ fontSize: "12px" }}>INDICATOR</th> <th rowSpan={2} style={{ fontSize: "12px" }}>UNIT</th> <th colSpan={1} style={{ fontSize: "12px" }}>ANNUAL ACHIEVEMENTS</th> <th colSpan={5} style={{ fontSize: "12px" }}>ANNUAL TARGETS</th> <th rowSpan={2} style={{ fontSize: "12px" }}>Indicative Financial Plan - Expected sources of<br /> funding (CSS, State Plan, NGOs,<br /> CSR Contributions, etc.)</th> </tr> <tr> <th style={{ fontSize: "12px" }}>2023-24</th> <th style={{ fontSize: "12px" }}>2024-25</th> <th style={{ fontSize: "12px" }}>2025-26</th> <th style={{ fontSize: "12px" }}>2026-27</th> <th style={{ fontSize: "12px" }}>2027-28</th> <th style={{ fontSize: "12px" }}>2028-29</th> </tr> </thead>
                          <tbody>
                            {data54?.length === 0 || data54?.length === undefined ? (
                              <tr>
                                <td colSpan={11} className="text-center" style={{ color: "red" }}>Details Not Found</td>
                              </tr>
                            ) : (
                              data54?.map((detail, i) => (
                                <tr key={i}> <td style={{ fontSize: "11px", textAlign: "center" }}>{i + 1}</td> <td style={{ fontSize: "11px", textAlign: "left" }}>{detail.sub_indicator_name}</td> <td style={{ fontSize: "11px", textAlign: "left" }}>{detail.unit}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.achived}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2024_2025}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2025_2026}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2026_2027}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2027_2028}</td> <td style={{ fontSize: "11px", textAlign: "right" }}>{detail.target_2028_2029}</td> <td style={{ fontSize: "11px", textAlign: "center" }}>{detail.source_of_funding}</td> </tr>
                              ))
                            )}
                          </tbody>
                        </DESUI.Table>
                      </Col>
                    </Row>

                    <Row style={{ width: "75%" }}>
                      <Col xs={12} className="agr-secto"> <JoditEditor ref={(el) => (editorRefs.current["mandaldevelopment"] = el)} value={targettext || ""} config={configEditor} tabIndex={1} /> </Col>
                    </Row>
                  </Container>

                  <div className="d-flex justify-content-center bottom-buttons"> <Button onClick={() => Preview1()} style={{ marginTop: "20px" }} size="sm" className="next-btn me-4"> Preview <FaEye className="ms-1 s-icon" /> </Button> {bookfreez === "2" && <Button onClick={() => handleSubmit4("mandaldevelopment", 5)} style={{ marginTop: "20px" }} size="sm" className="save-btn me-4"> Save <FaRegSave className="ms-1 s-icon" /> </Button>} <Button onClick={() => setKey("wayforward")} style={{ marginTop: "20px" }} size="sm" className="save-btn me-4"> Next <FaArrowRightLong className="ms-1 n-icon" /> </Button> </div>

                </Tab>


                <Tab eventKey="wayforward" title="6-Way Forward " className="">


                  <Container>
                    <JoditEditor ref={(el) => (editorRefs.current["wayforward"] = el)} value={wayforward || ""} config={configEditor} tabIndex={1} />
                    <div className="d-flex justify-content-center bottom-buttons">
                      <Button onClick={() => Preview5()} style={{ marginTop: "20px" }} size="sm" className="next-btn me-4" >
                        Preview <FaEye className="ms-1 s-icon" />
                      </Button>

                      {bookfreez === "2" && <Button onClick={() => handleSubmit5("wayforward", 6)} style={{ marginTop: "20px" }} size="sm" className="save-btn  me-4" > Save <FaRegSave className="ms-1 s-icon" /> </Button>} <Button onClick={() => setKey("indexPage")} style={{ marginTop: "20px" }} size="sm" className="save-btn me-4"> Next <FaArrowRightLong className="ms-1 n-icon" /> </Button> {enteredtabs === "6" && (<><Button onClick={() => handleSubmit6()} style={{ marginTop: "20px" }} size="sm" className="save-btn  me-4" > Book Content Pdf<ImPrinter className="ms-1 s-icon" /> </Button> <Button onClick={() => exportToWord()} style={{ marginTop: "20px" }} size="sm" className="save-btn me-4" > Book Content Word<FaFileWord className="ms-1 s-icon" /> </Button> </>)}
                    </div>
                  </Container>


                  <Modal fade={false} aria-labelledby="contained-modal-title-vcenter" className="newmodal" centered show={addModal5} size="xl">
                    <Modal.Header >
                      <Modal.Title className="text-center">Way Forward</Modal.Title>
                     <span role="button" tabIndex="0" aria-label="Close" onClick={handleClose5} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault();  handleClose5(); } }} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "white")} style={{ cursor: "pointer" }} > &#215; </span>

                    </Modal.Header>
                    <Modal.Body className="p-5"> <div className="html-container" > </div> <div className="d-flex justify-content-end"> <button className="btn btn-danger" onClick={() => { setAddModal5(false); }} type="button" style={{ borderRadius: "20px" }}><RiCloseCircleLine />  Close</button> </div> </Modal.Body>
                  </Modal>

                </Tab>


                <Tab eventKey="indexPage" title="7-Index/Content " className="">
                  <Container>
                    <JoditEditor ref={(el) => (editorRefs.current["indexPage"] = el)} value={indexPage || ""} config={configEditor} tabIndex={1} />
                    <div className="d-flex justify-content-center bottom-buttons"> {bookfreez === "2" && <Button onClick={() => handleSubmit7("indexPage", 7)} style={{ marginTop: "20px" }} size="sm" className="save-btn  me-4" > Save <FaRegSave className="ms-1 s-icon" /> </Button>} </div>
                  </Container>
                </Tab>
              </Tabs>
            </Form>
          </FormikProvider>
        </Container>
        }
      </>}



      {roleid !== "3" &&
        <Container style={{ marginBottom: "60px" }}>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Row className="justify-content-center">
                <Col xs={6} sm={12} lg={9} md={9} xl={9} xxl={9}>
                  <div className="input-group mt-2">
                    <div className="input-group-prepend">
                      <div class="input-group-text group_txt11" id="btnGroupAddon"><AiOutlineSearch /></div></div>
                    <input type="text" className="form-control" placeholder="Search" onChange={(event) => setSearchTextStatus(event.target.value)} />
                  </div>
                
                  <table className="table table-bordered custom-table table-responsive mt-5" >
                    <thead >
                      <tr className="text-center"> <th >Sl.No.</th> <th >Mandal</th> <th >Book Staus</th> {(statusData?.some(detail => detail.book_status === "Book Generated") && roleid !== "10") && ( <th>Book Finalize/Revise</th> )} </tr>
                    </thead>
                    <tbody>
                      {filteredDataStatus?.length === 0 ? (
                        <tr> <td className="text-center fw-bold" style={{ color: "red" }} colSpan={5}> Details Not Found </td> </tr>
                      ) : (
                        filteredDataStatus?.map((detail, i) => (
                          <tr key={i}>
                            <td style={{ textAlign: 'center' }}> {i + 1} </td> <td className="text-left"> {detail.mandal_name} </td>

                            <td className="text-center">
                              {detail.book_status === "Book Generated" ?
                                <Link
                                  style={{ cursor: "pointer", color: "green", textDecoration: "none", fontFamily: "sans-serif", fontSize: "14px" }}
                                  onClick={() => { Mandalpdf(detail) }}
                                >
                                  {detail.book_status} <FaDownload style={{ fontSize: "19px", marginBottom: "5px" }} />
                                </Link>
                                : (
                                  detail.book_status
                                )}
                            </td>


                            {detail.book_status === "Book Generated" && roleid !== "10" ? (
                              <td className="text-center d-flex justify-content-center p-0 m-0">
                                <Field component="select" className="form-control p-2 m-1" name={`bookfreez[${i}]`} onChange={(e) => Freezfunction(e, detail, i)} > <option value="1">--Freeze Editing--</option> <option value="2">--Unfreeze for Changes--</option> </Field>
                              </td>
                            ) : null}



                          </tr>
                        ))
                      )}
                    </tbody>

                  </table>
                </Col>

              </Row>
            </Form>
          </FormikProvider>
        </Container>
      }






      <Modal fade={false} aria-labelledby="contained-modal-title-vcenter" className="newmodal" centered show={addModal2} size="xl" style={{ marginBottom: "1rem", textAlign: "center" }}>
        <Modal.Header >
          <Modal.Title className="text-center">Cover Page</Modal.Title>
        <span role="button" tabIndex="0" aria-label="Close" onClick={handleClose2} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClose2(); } }} style={{ cursor: "pointer" }} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "white")} > &#215; </span>

        </Modal.Header>
        <Modal.Body className="p-5"> <div className="html-container" > </div> <div className="d-flex justify-content-end"> <button className="btn btn-danger" onClick={() => { setAddModal2(false); }} type="button" style={{ borderRadius: "20px" }}><RiCloseCircleLine />  Close</button> </div> </Modal.Body>
      </Modal>



      <Modal fade={false} aria-labelledby="contained-modal-title-vcenter" className="newmodal" centered show={addModal1} size="xl">
        <Modal.Header>
          <Modal.Title className="text-center">Mandal Development</Modal.Title>
<span role="button" tabIndex="0" aria-label="Close" onClick={handleClose} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClose(); } }} style={{ cursor: "pointer" }} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "white")} > &#215; </span>

        </Modal.Header>
        <Modal.Body className="p-5 d-flex flex-column justify-content-between" style={{ height: "100%" }}> <div className="html-container p-2"> </div> <div className="d-flex justify-content-end" style={{ bottom: "0px" }}> <button className="btn btn-danger" onClick={() => { setAddModal1(false); }} type="button" style={{ borderRadius: "20px" }}><RiCloseCircleLine />  Close</button> </div> </Modal.Body>
      </Modal>

      <Modal fade={false} aria-labelledby="contained-modal-title-vcenter" className="newmodal" centered show={addModal} size="xl">
        <Modal.Header >
          <Modal.Title className="text-center">Economic Perspective</Modal.Title>
<span role="button" tabIndex="0" aria-label="Close" onClick={handleClose} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClose(); } }} style={{ cursor: "pointer" }} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "white")} > &#215; </span>

        </Modal.Header>
        <Modal.Body className="p-5">
          <div className="html-container" >



          </div>
          <div className="d-flex justify-content-end">
            <button className="btn btn-danger" onClick={() => { setAddModal(false); }} type="button" style={{ borderRadius: "20px" }}><RiCloseCircleLine />  Close</button>
          </div>
        </Modal.Body>
      </Modal>

      {subEnb && (
        
          <Container fluid style={{ width: "80%", border: "1px solid black" }} className="p-4">
            <div className="d-flex justify-content-center bottom-buttons">
              <button onClick={Back} className="next-btn">Back</button>

            </div>

            <div className="html-container p-5" ref={contentRef} >
            </div>


          </Container>
        
      )}



      {subEnb1 && (
        <Container fluid style={{ width: "80%", border: "1px solid black", marginBottom: '10rem' }} className="p-4">
          <div className="d-flex justify-content-center bottom-buttons">
            <button onClick={Back} className="next-btn mx-4">Back</button>
            <button onClick={handlePrint} className="download-btn">Download Print <IoPrint /></button>
          </div>
          <div className="d-flex justify-content-center">
            <div className="html-container1 p-4" style={{ backgroundImage: `url(${backgroundImage})`, backgroundRepeat: "no-repeat", width: '100%', height: '100vh', position: 'relative' }}>
            </div>
          </div>
        </Container>
      )}


      {indexEnb &&
        <Container>
          <h2>CONTENTS</h2>
          <DESUI.Table className="table table-bordered custom-table table-responsive mt-5" id="my-tableindex" style={{ width: "60%" }}>
            <thead style={{ backgroundColor: "lightgreen" }}>
              <tr className="text-center">
                <th>Sl. No.</th>
                <th>Chapter</th>
              </tr>
            </thead>
            <tbody>
              {(() => {

                const groupedData = indexdata.reduce((acc, curr) => {
                  const index = acc.find(item => item.index_id === curr.index_id);
                  if (index) {
                    index.sub_indexes.push(curr);
                  } else {
                    acc.push({
                      index_id: curr.index_id,
                      index_name: curr.index_name,
                      display_order: curr.display_order,
                      sub_indexes: [curr]
                    });
                  }
                  return acc;
                }, []).sort((a, b) => a.display_order - b.display_order);

                return groupedData.length === 0 ? (
                  <tr>
                    <td colSpan={2} className="text-center" style={{ color: "red" }}>Details Not Found</td>
                  </tr>
                ) : (
                  groupedData.map((index, indexIdx) => (
                    <React.Fragment key={index.index_id}>
                      <tr>
                        <td style={{ textAlign: "center" }}>{indexIdx + 1}</td>
                        <td className="text-left">{index.index_name}</td>
                      </tr>
                      {index.sub_indexes.map((subIndex, subIndexIdx) => (
                        <tr key={subIndex.sub_index_id}>
                          <td style={{ textAlign: "right" }} >{`${indexIdx + 1}.${subIndexIdx + 1}`}</td>
                          <td className="text-left" style={{ marginleft: "10px" }}>&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;{subIndex.sub_index_name}</td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))
                );
              })()}
            </tbody>
          </DESUI.Table>


        </Container>
      }
<div style={{marginBottom:"10px"}} id="coverpicid"  className='hidden'>
      <div><img src={base64Stringimg1} alt="Background Image1" style={{ width: '620px',  }} />
      </div>
      <div style={{ position: 'relative', width: '620px', height: 'auto', overflow: 'hidden' }}>
  <img src={base64Stringimg2} alt="Background" style={{ position: 'absolute', top: 0, left: 0,width: '620px',  }} />
  <p style={{ position: 'relative', color: 'black', fontWeight: 'bold', zIndex: 1 ,padding:"2px"}}>Mandal</p>
  <p style={{ position: 'relative', color: 'black', fontWeight: 'bold', zIndex: 1 }}>District</p>
</div>
      <div className="d-flex">
      {formik.values.coverpic1 && ( <img src={formik.values.coverpic1} alt="Cover Pic 1" style={{ width: '310px', height: '200px', }} /> )}
      {formik.values.coverpic2 && ( <img src={formik.values.coverpic2} alt="Cover Pic 2" style={{ width: '310px', height: '200px',}} width="310" height="200" /> )}
      </div>
      <img src={base64Stringimg3} alt="Background Image3" style={{ width: '620px',}} /> </div>
 





      <style jsx>{`.custom-tabs .nav-item { margin-right: 1px;  font-weight:bold !important;border-bottom:2px solid #C7C7C7 !important; } .custom-tabs .nav-link {background-image: linear-gradient(180deg,rgba(246,238,232,1),rgba(246,238,232,0.1)) !important;display: flex;align-items: center;justify-content: center;} .custom-tabs .nav-link.active { background-color: transparent !important;color: black !important;background-image: linear-gradient(180deg,rgba(195,229,190,1),rgba(195,229,190,0.1)) !important;color: var(--bs-nav-pills-link-active-color);height:75px !important; border-radius: 0px !important; display: flex !important;align-items: center !important; justify-content: center !important;} .custom-tabs .nav-item + .nav-item { border-left: 1px solid #dee2e6; } #functions-subtabs .nav-item + .nav-item { border-left: 1px solid #dee2e6; }} `}</style>
    </>
  );
};

export default BookGeneration;


